import gql from 'graphql-tag';

import client from '../graphqlAPI';

// Save the contents of ONE table cell, leaving every other byte of the
// document alone.
//
// A sibling of editEmailTemplate, not a replacement: whole-document saves
// still go through that one. The difference is only where the new htmlContent
// comes from - here the server splices it at the offsets its own scan reported
// for the string it currently holds, so the client never composes a body and
// can never smear an edit across the table chrome around it. Everything after
// the splice (validate, snapshot a revision, recompute `variables`, clear the
// render cache) is identical, because a cell edit is a save.
//
// The returned template is the whole post-save document, the same selection
// editEmailTemplate returns, because a cell edit changes htmlContent: the
// editor must replace its draft with this or the next whole-document save
// would write the pre-edit body back over it. The cells themselves are NOT
// selected here - the editor re-reads them through getEmailTemplateCells,
// which is keyed on `template` and so re-runs on this update. One source of
// truth for the cell list, and it re-reads after every save, which it must:
// ids are ordinals and offsets move whenever content length changes.
const EDIT_EMAIL_TEMPLATE_CELL_MUTATION = gql`
  mutation editEmailTemplateCell($templateId: String!, $cellId: String!, $innerHtml: String!) {
    editEmailTemplateCell(templateId: $templateId, cellId: $cellId, innerHtml: $innerHtml) {
      isAuth
      success
      error
      template {
        _id
        templateId
        name
        language
        scope
        subject
        preheader
        htmlContent
        textContent
        sampleData
        needsReview
        variables
        isActive
        source
        appName
        updatedAt
        revisions {
          author
          savedAt
        }
      }
    }
  }
`;

const editEmailTemplateCell = async ({ templateId, cellId, innerHtml }) => {
  try {
    const result = await client
      .mutate({
        mutation: EDIT_EMAIL_TEMPLATE_CELL_MUTATION,
        variables: { templateId, cellId, innerHtml },
        fetchPolicy: 'no-cache',
      })
      .then(mutationResult => mutationResult)
      .catch((mutationError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Mutation Error: ${mutationError}`);
        return null;
      });

    const { data: { editEmailTemplateCell: editCellData } } = result;

    if (editCellData) return editCellData;

    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Mutation Error: editEmailTemplateCell = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: editEmailTemplateCell Error: ${error}`);
    return null;
  }
};

export default editEmailTemplateCell;
